import { createSvgIcon } from '@mui/material'

export const FundsFillIcon = createSvgIcon(
  <path d="M3.897 17.86L7.807 13.95L10.636 16.778L15.207 12.208L17 14V9H12L13.793 10.793L10.636 13.95L7.808 11.121L2.862 16.067C2.29193 14.787 1.9982 13.4012 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C10.418 22.001 8.85838 21.6262 7.44961 20.9065C6.04083 20.1867 4.8232 19.1425 3.897 17.86Z" />,
  'FundsFill'
)
